import i18n from './../../shared/i18n';

import BaseModel from "../../core/components/input-widget/BaseModel";
import {Formatter} from "@/core/services/formatter.service";
import ReceiptItemLocationModel from "@/modules/receipt/ReceiptItemLocation.model";

export default class ReceiptModel extends BaseModel {
  uuid = null;
  receipt_no = null;
  receipt_prefix = null;
  customer_select = null;
  date = Formatter.getNowAsDate();
  department_uuid = null;
  description = null;
  insurance_value = null;
  status = null;
  containers_count = null;
  container_type = null;
  miscellaneous_items = [];
  specialists_uuids = [];
  specialists = [];
  rep_user_uuid = null;
  item_location_uuid = null;
  dropper_uuid = null;
  receipt_type = null;
  enable_multiple_locations = false;
  item_locations = [];

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    for (let i in this.item_locations) {
      this.item_locations[i] = new ReceiptItemLocationModel(this.item_locations[i]);
    }

    this.initDynamicFields(this, this.branch ? this.branch.receipt_dynamic_fields_template : null);
  }

  rules = {
    customer_uuid: 'required',
    receipt_type: 'required',
    receipt_prefix: 'max:5',
  };

  attributeHints = {
    receipt_no: i18n.t('If you leave this blank it will be automatically generated')
    // receipt_prefix: i18n.t('If you leave this blank it will be automatically generated')
  };

  attributeLabels = {
    uuid: i18n.t('UUID'),
    receipt_no: i18n.t('Receipt'),
    receipt_prefix: i18n.t('Receipt Prefix'),
    customer_uuid: i18n.t('Customer'),
    date: i18n.t('Date'),
    recommended_by_uuid: i18n.t('Recommended By Customer'),
    recommended_by_user_uuid: i18n.t('Recommended By User'),
    specialists_uuids: i18n.t('Specialists'),
    department_uuid: i18n.t('Department'),
    description: i18n.t('Description'),
    branch: i18n.t('Branch'),
    customer: i18n.t('Customer'),
    department: i18n.t('Department'),
    unsold_fee: i18n.t('Unsold Fee'),
    Description: i18n.t('Description'),
    received_by: i18n.t('Received By'),
    insurance_rate: i18n.t('L/D Warranty'),
    recommended_by: i18n.t('Recommended By'),
    withdrawal_fee: i18n.t('Withdrawal Fee'),
    minimum_commission: i18n.t('Minimum Commission'),
    lot_handling_charge: i18n.t('Lot Handling Charge'),
    insurance_value: i18n.t('Insurance Value'),
    status: i18n.t('Status'),
    containers_count: i18n.t('Number of Containers'),
    container_type: i18n.t('Type of Container'),
    rep_user_uuid: i18n.t('Representative User'),
    item_location_uuid: i18n.t('Item Location'),
    item_location: i18n.t('Item Location'),
    dropper_uuid: i18n.t('Dropper'),
    receipt_type: i18n.t('Receipt Type'),
    item_locations: i18n.t('Item Locations'),
    enable_multiple_locations: i18n.t('Enable Multiple Locations'),
  };
}
